export default __webpack_public_path__ + "static/media/bmi-cover.2d619564.gif";